export enum DiscoPublisherStatus {
  Pending = "PENDING",
  NeedsInfo = "NEEDS_INFO",
  Approved = "APPROVED",
  Rejected = "REJECTED",
}
